import {Directive, ElementRef, EventEmitter, Output} from '@angular/core';

const selectorName: string = 'onElementResized';

@Directive({
    selector: `[${selectorName}]`,
    standalone: false
})
export class OnElementResizedDirective {

	@Output(selectorName)
	public onElementResized: EventEmitter<{ elementRef: ElementRef, contentRect: DOMRectReadOnly }> = new EventEmitter<{ elementRef: ElementRef, contentRect: DOMRectReadOnly }>();

	constructor(
		private _elementRef: ElementRef,
	) {
		const resizeObserver: ResizeObserver = new ResizeObserver(
			(entries: ResizeObserverEntry[], observer: ResizeObserver): void => {
				for (const entry of entries) {
					if (entry.contentRect) {
						this.onElementResized.emit(
							{
								elementRef: this._elementRef,
								contentRect: entry.contentRect
							}
						);
					}
				}
			}
		);

		resizeObserver.observe(this._elementRef.nativeElement);
	}
}
